import Stack from "@mui/material/Stack";
import { ReactNode } from "react";

/**
 * Where the map's own controls live: a column down the right-hand edge.
 *
 * Stacked rather than each one positioned for itself. The page puts its full-screen button in the
 * top right corner, and every control that placed itself absolutely had to know about that corner
 * and about every other control — which is how the compass ended up on top of the full-screen
 * button. Anything added here simply queues up below.
 */
export function MapControlStack({ children }: { children: ReactNode }) {
  return (
    <Stack
      spacing={1}
      alignItems="flex-end"
      sx={{
        position: "absolute",
        // Below the page's full-screen button, which sits at the very top of the corner.
        top: 56,
        right: 8,
        zIndex: 900,
        // The gaps between the controls stay clickable on the map underneath.
        pointerEvents: "none",
        "& > *": { pointerEvents: "auto" },
      }}
    >
      {children}
    </Stack>
  );
}
